import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../services/api";
import { ConfirmDialog, } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import './PM_DASHBOARD.css';  // Import the new CSS

const PM_DASHBOARD = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [projects, setProjects] = useState([]);
    const [searchprojects, setSearchprojectsProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);


    /** //*search Filtter function Start */
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        if (_filters['global']) {
            _filters['global'].value = value;
        } else {
             _filters['global'] = { value: value, matchMode: FilterMatchMode.CONTAINS };
        }

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            ProjectType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            pM: { value: null, matchMode: FilterMatchMode.CONTAINS },
            development_manager: { value: null, matchMode: FilterMatchMode.CONTAINS },
            pre_con_manager: { value: null, matchMode: FilterMatchMode.CONTAINS },
            interior_design: { value: null, matchMode: FilterMatchMode.CONTAINS },
            job_autospy: { value: null, matchMode: FilterMatchMode.CONTAINS },
            warranty: { value: null, matchMode: FilterMatchMode.CONTAINS },
            new_status: { value: null, matchMode: FilterMatchMode.EQUALS }
        });
        setGlobalFilterValue('');
    };
    /** //!search Filtter function End */

    
    const header = (
        <div className="pm-dashboard-header" style={{ justifyContent: 'flex-end' }}>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    className="modern-input"
                    type="search"
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder="Search Projects..."
                />
            </span>
        </div>
    );

    var ProjectStatusList = ['ACTIVE', 'WARRANTY', 'ARCHIVE', 'HOLD', 'CANCELLED', 'COMPLETED'];

    useEffect(() => {
        let playbookSelectedColumnField = localStorage.getItem('playbookSelectedColumnField')

        if (playbookSelectedColumnField) {

            if (playbookSelectedColumnField != null && playbookSelectedColumnField != 'null') {
                setSelectedColumnField(playbookSelectedColumnField)
                getProject(playbookSelectedColumnField);
            } else {
                getProject('ALL');
            }
        } else {
            getProject('ALL');
        }



        initFilters();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, [activeIndex]);


    const getProject = async (projectStatus) => {
        setIsLoading(true);
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };



        var _body = {

            status: projectStatus,
        }
        fetch(Api.API_BASE_URL + 'pm-template/all-project-get-by-status', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                
                const enrichedProjects = response.result.map(project => ({
                    ...project,
                    pM: `${project.first_name || ''} ${project.last_name || ''}`,
                    development_manager: `${project.da_first_name || ''} ${project.da_last_name || ''}`,
                    pre_con_manager: `${project.pcm_first_name || ''} ${project.pcm_last_name || ''}`,
                    interior_design: `${project.ind_first_name || ''} ${project.ind_last_name || ''}`,
                    job_autospy: `${project.Ja_first_name || ''} ${project.Ja_last_name || ''}`,
                    warranty: `${project.Wa_first_name || ''} ${project.Wa_last_name || ''}`
                }));

                setProjects(enrichedProjects);
                setSearchprojectsProjects(enrichedProjects);
                setIsLoading(false);


                let playbookRedirect = localStorage.getItem('playbookRedirect');
                if (playbookRedirect) {
                    playbookRedirect = JSON.parse(playbookRedirect)
                    setFirst(playbookRedirect.first || 0)
                    setRows(playbookRedirect.rows || 15)
                    setSortField(playbookRedirect.sortField || 'project_name')
                    setSortOrder(playbookRedirect.sortOrder || -1)

                } let playbookSelectedProduct = localStorage.getItem('playbookSelectedProduct');
                if (playbookSelectedProduct) {
                    playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                    setSelectedProduct(playbookSelectedProduct)


                }

                localStorage.removeItem('playbookSelectedProduct')
                localStorage.removeItem('playbookRedirect');
                localStorage.removeItem('playbookSelectedColumnField');


            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
    };

    // ------------------------------------
    const edit = (id, projectId, value) => {
        localStorage.setItem('playbookRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))


        localStorage.setItem('playbookSelectedProduct', JSON.stringify(value))
        localStorage.setItem('playbookSelectedColumnField', selectedColumnField)


        navigate('/view-playbook/' + projectId)
    }



    // ------------------------------------

    //* -------------------------

    const [selectedColumnField, setSelectedColumnField] = useState(null);

    const statusItemTemplate = (option) => {

        // *--------- Suraj Added 09-12-2024 ------------------
        console.log('option', option);
        let x = option;
        if (option == 'Warranty') {
            x = 'Warranty Complete'
        }
        if (option == 'Complete') {
            x = 'Construction Complete'
        }
        if (option == 'FSA Active') {
            x = 'FSA Construction'
        }
        // !--------- Suraj Added 09-12-2024 ------------------

        const displayStatus = option === 'ARCHIVE' ? 'COMPLETE' : option;

        const color = getSeverity(displayStatus);
        // return <Tag value={displayStatus} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;
        return <Tag value={x} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;


    };

    const getSeverity = (status) => {

        switch (status) {

            case 'Opportunity':
                return '#FFC107';

            case 'Lead Closed':
                return '#003366';

            case 'Lead Lost':
                return '#A9A9A9';

            case 'Lead Hold':
                return '#FFA500';

            case 'Lead Turned Down':
                return '#4F4F4F';

            case 'FSA Development':
                return '#87CEEB';

            case 'FSA Construction':
                return '#228B22';
            case 'FSA Active':
                return '#228B22';

            case 'FSA Hold':
                return '#556B2F';

            case 'FSA Cancelled':
                return '#8B0000';

            case 'Contract Active':
                return '#2E8B57';

            case 'Contract Hold':
                return '#D4AF37';

            case 'Contract Cancelled':
                return '#DC143C';

            case 'Construction Start':
                return '#FFA500';

            case 'Construction Complete':
                return '#4682B4';

            case 'Warranty Complete':
                return '#708090';

            default:
                return '#00AC47';
        }
    };

    const textRowFilterTemplate = (options) => {
        return (
            <div className="pm-filter-container">
                <InputText
                    value={options.value || ''}
                    onChange={(e) => options.filterApplyCallback(e.target.value)}
                    className="pm-filter-input"
                    placeholder={options.column?.props?.filterPlaceholder || `Search ${options.column?.props?.header || ''}`}
                />
            </div>
        );
    };

    const projectStatusRowFilterTemplate = (options) => {
        return (
            <div className="pm-filter-container">
                <Dropdown 
                    value={options.value} 
                    options={options.field === 'new_status' ? ['FSA Development', 'FSA Construction', 'FSA Hold', 'FSA Cancelled', 'Contract Active', 'Contract Hold', 'Contract Cancelled', 'Construction Start', 'Construction Complete', 'Warranty Complete'] : []} 
                    onChange={(e) => options.filterApplyCallback(e.value)}
                    itemTemplate={statusItemTemplate} 
                    placeholder="Select One" 
                    className="pm-filter-dropdown" 
                    showClear 
                />
            </div>
        );
    };

    //! -------------------------
    const onRowSelect = (e) => {
        const rowData = e.data;
        setSelectedProduct(e.data)
        edit(e.data.id, e.data.projectId, e.data);
    };

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [sortField, setSortField] = useState('project_name');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }
    const DataTableTabView = () => {
        return (
            <div className="pm-table-wrapper" >
                <DataTable
                    value={projects}
                    paginator
                    rows={rows}
                    first={first}
                    onPage={(e) => {
                        setFirst(e.first);
                        setRows(e.rows);
                    }}
                    
                    filterDisplay="row"
                    dataKey="id"
                    filters={filters}
                    onFilter={(e) => setFilters(e.filters)}
                    globalFilterFields={['project_name', 'ProjectType', 'pM', 'development_manager', 'pre_con_manager', 'interior_design', 'job_autospy', 'warranty']} // Added new global filter fields

                    selectionMode="single"
                    selection={selectedProduct}
                    onRowSelect={onRowSelect}
                    onRowUnselect={onRowSelect}

                    className="pm-datatable compact-datatable" // Added compact-datatable class
                    scrollable
                    scrollHeight="flex"
                    stripedRows
                    size="small"
                    
                    rowsPerPageOptions={[20, 50, 100, 250]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Projects"
                >

                    <Column sortable field="new_status" header="Project Status" body={(e) => statusItemTemplate(e.new_status)}  style={{ minWidth: '15rem', textAlign: 'left' }} filter filterElement={projectStatusRowFilterTemplate} showFilterMenu={false}></Column>

                    <Column sortable field="project_name" header="Project Name" style={{ minWidth: '200px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search Project Name"></Column>
                    <Column sortable field="ProjectType" header="Project Type" style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search Type"></Column>
                    <Column sortable field="pM" header="Project Manager" body={(e) => <span>{e.first_name} {e.last_name}</span>} style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search PM"></Column>
                    <Column sortable field="development_manager" header="Development Manager" body={(e) => <span>{e.da_first_name} {e.da_last_name}</span>} style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search DM"></Column>
                    <Column sortable field="pre_con_manager" header="Pre con Manager" body={(e) => <span>{e.pcm_first_name} {e.pcm_last_name}</span>} style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search PCM"></Column>
                    <Column sortable field="interior_design" header="Interior Designer Manager" body={(e) => <span>{e.ind_first_name} {e.ind_last_name}</span>} style={{ minWidth: '180px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search IDM"></Column>
                    <Column sortable field="job_autospy" header="JOB AUTOPSY" body={(e) => <span>{e.Ja_first_name} {e.Ja_last_name}</span>} style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search JA"></Column>
                    <Column sortable field="warranty" header="Warranty" body={(e) => <span>{e.Wa_first_name} {e.Wa_last_name}</span>} style={{ minWidth: '150px' }} filter filterElement={textRowFilterTemplate} showFilterMenu={false} filterPlaceholder="Search Warranty"></Column>
                </DataTable>
            </div>
        )
    }


    return (
        <><Toast ref={toast} />
            <ConfirmDialog />
            <div className="pm-dashboard-container">
            <div className="pm-dashboard-card">

                {isLoading ? (
                    <div className="loading-spinner">
                        Loading...
                        <div className="spinner"></div>
                    </div>
                ) : (

                    <>
                        <div className="pm-dashboard-header">
                            <h2 className="pm-page-title">Playbooks</h2>
                            <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText
                                    className="modern-input"
                                    type="search"
                                    value={globalFilterValue}
                                    onChange={onGlobalFilterChange}
                                    placeholder="Search Projects..."
                                />
                            </span>
                        </div>
                        {DataTableTabView()}
                    </>
                    
                )}
            </div>
            </div>
        </>
    )
}

export default PM_DASHBOARD;